import {Odds} from "../../types/Odds";
import {BestForMarket} from "../../types/BestForMarket";
import Market from "../../types/Market";
import { Bookmaker } from "../../types/Bookmaker";
import { BestOdds } from "../../types/BestOdds";
import { Outcome } from "../../types/Outcome";
import { Leagues } from "../../types/Leagues";
import leagueList from "../data/league-list.json"
import { allBookmakersWithSource } from "../constants";




const bookMakersToSkip: string[]=["betfair"];

export function jsonArrToOddsArr(jsonList: any[]) {
  if (!Array.isArray(jsonList)) {
    console.error('jsonList is not an array:', jsonList);
    return [];
  }

  let jsonArr: Array<Odds> = [];
  jsonList.forEach(function (json){
    jsonArr.push(jsonToOdds(json));
  });
  
  return jsonArr;
}


export function bookmakersToKeyList(bookmakers: Bookmaker[]): string[] {
  const keyList: string[] = [];
  for (const bookmaker of bookmakers) {
    keyList.push(bookmaker.key);
  }
  return keyList;
}

export function jsonToOdds(json: any): Odds {
  return {
    id: json.id,
    sport_key: json.sport_key,
    sport_title: json.sport_title,
    commence_time: json.commence_time,
    home_team: json.home_team,
    away_team: json.away_team,
    start_time: json.start_time,
    bookmakers: json.bookmakers.map((bookmaker: any) => {
      return {
        key: bookmaker.key,
        title: bookmaker.title,
        last_update: bookmaker.last_update,
        juice: 0,
        markets: bookmaker.markets.map((market: any) => {
          return {
            key: market.key,
            juice: calculateJuice(market.outcomes),
            outcomes: market.outcomes.map((outcome: any) => {
              return {
                name: outcome.name,
                price: outcome.price,
                usaFormat: outcome.price,
                point : outcome.point,
              }
            })
          }
        })
      }
    })
  }
}

export function calculateJuice(outcomes: Outcome[]){
   return (calculateSumOfProbabilties(outcomes)- 1)*100;
}



export function calculateSumOfProbabilties(outcomes: Outcome[]){
    let totalProbabilty : number = 0;
    outcomes.forEach(function (outcome) {  
        totalProbabilty += outcomeToImpliedProbability(outcome);
    });;
    return totalProbabilty;   
}

 export function outcomeToImpliedProbability(outcome: Outcome){ 
    return calculateImpliedProbabilityFromAmericanOdds(outcome.price as number);
}

export function formatOdds(
  price: number | undefined,
  isTotal: boolean
): string | undefined {
  if (price === Number.MIN_SAFE_INTEGER) return "--";
  if (price === undefined) return price;
  return price && price > 0 && !isTotal ? "+" + price : price.toString();
}



export function decimalToAmerican(decimalOdds: number): number {
  return decimalOdds < 2 ? -Math.round(100 / (decimalOdds - 1)) : Math.round((decimalOdds - 1) * 100);
}

function calculateImpliedProbabilityFromAmericanOdds(odds: number): number {
  return odds>0 ? 100 / (odds + 100) :(-odds) / (-odds + 100);
}

function shouldExclude(key:string): boolean {
  return bookMakersToSkip.includes(key);
}

export function getBestByMarketKey(bests: BestForMarket[], key: string): BestForMarket {
  return bests.filter(best => best.market.key=== key)[0];
}

export function getImagePathByMarketKey(key: string): string {
  if (!key) return "";
  const bookmakerKeyPathMap = new Map<string, string >(); ;


 // "https://play-lh.googleusercontent.com/BctQd9Bq2q6GJYUL80jwTaGcl05RFeany_m_IU5_wOa2QpEInGkPKPXg6TWIhup-KHE"
  bookmakerKeyPathMap.set("pointsbetus","https://pbs.twimg.com/profile_images/1433898552451686402/cD2kPDuX_400x400.png");
  bookmakerKeyPathMap.set("draftkings","https://brandstruck.co/wp-content/uploads/2021/03/DraftKings-brand-strategy-positioning.jpeg");
  bookmakerKeyPathMap.set("fanduel","https://images.actionnetwork.com/1200x675/blog/2022/08/FanDuel.webp");
  bookmakerKeyPathMap.set("betmgm","https://www.sportsvideo.org/wp-content/uploads/2020/03/BetMGM-Logo-%E2%80%93-HiRes.png");
  bookmakerKeyPathMap.set("betfair","https://www.esports.net/br/wp-content/uploads/sites/3/2022/08/betfair-logo.jpg");
  bookmakerKeyPathMap.set("barstool","https://logos-world.net/wp-content/uploads/2022/01/Barstool-Sports-Symbol.png");
  bookmakerKeyPathMap.set("betonlineag","https://static.casinousa.com/images//casino-rooms/betonline-logo.jpg");
  bookmakerKeyPathMap.set("foxbet","https://www.betphilly.com/wp-content/uploads/sites/18/2022/02/fox-bet.jpg");
  bookmakerKeyPathMap.set("mybookieag","https://cdn.mybookie.ag/wp-content/uploads/mybookie-sportsbook-01.jpg");
  bookmakerKeyPathMap.set("circasports","https://www.circasports.com/wp-content/uploads/2020/06/circa-sports-logo-vertical-white.png");
  bookmakerKeyPathMap.set("lowvig","https://ui.lowvig.ag/images/promotions/mit-240-poster-home-video.jpg");
  bookmakerKeyPathMap.set("unibet_us","  https://i0.wp.com/thelibertyline.com/wp-content/uploads/2022/03/THE-WOLVES-OF-BROAD-STREET-40.png?resize=1200%2C675&ssl=1");

 // bookmakerKeyPathMap.set("williamhill_us","https://www.google.com/url?sa=i&url=https%3A%2F%2Fwww.williamhill.us%2Fwilliam-hill-to-purchase-cg-technology-sports-book-assets%2F&psig=AOvVaw0agjzaEtSE_3kwlwGHH-jQ&ust=1675865263019000&source=images&cd=vfe&ved=0CA8QjRxqFwoTCKC7uN_Kg_0CFQAAAAAdAAAAABAE");
  bookmakerKeyPathMap.set("gtbets","http://sportsanalyticssimulator.com/wp-content/uploads/2018/03/gt-bets-logo.png");
  bookmakerKeyPathMap.set("betus","https://www.bangthebook.com/wp-content/uploads/2024/02/BetUS.jpg");
  bookmakerKeyPathMap.set("sugarhouse","https://img.sportsbookreview.com/images/sportsbooks/logos/sugarhouse-logo.png?fm=webp&auto=compress&auto=format");
  bookmakerKeyPathMap.set("williamhill_us","https://storage.googleapis.com/assestsbookiebrawler/bookmakerImages/caesars-2.webp");
  bookmakerKeyPathMap.set("twinspires","https://www.usbets.com/wp-content/uploads/2022/05/TwinSpires-Logo.jpeg");
  bookmakerKeyPathMap.set("wynnbet","https://www.letsgambleusa.com/wp-content/uploads/2021/08/wynnbet-logo.jpeg");
  bookmakerKeyPathMap.set("betrivers","https://storage.googleapis.com/assestsbookiebrawler/bookmakerImages/betrivers-2.webp");
  bookmakerKeyPathMap.set("bovada","https://static.uppromote.com/wp-content/uploads/2024/12/bovada-affiliate-program.jpg");
  bookmakerKeyPathMap.set("superbook","https://www.usbets.com/wp-content/uploads/2022/06/superbook-sports-logo.jpg");
  bookmakerKeyPathMap.set("pikkit","https://storage.googleapis.com/assestsbookiebrawler/bookmakerImages/pikkit-logo.webp");  
  bookmakerKeyPathMap.set("brawler", "https://storage.googleapis.com/assestsbookiebrawler/bookmakerImages/brawler-icon.png");
  bookmakerKeyPathMap.set("espnbet", "https://play-lh.googleusercontent.com/6F-FaTtBXOxH54dAmxFlfOe7SIpl9aZS1KniHfXxKuhtD5QYyrxk6KSt49RQ6_rwvkQuXIk7K2zuflzQ3SM=w480-h960-rw");
  bookmakerKeyPathMap.set("ballybet", "https://storage.googleapis.com/assestsbookiebrawler/bookmakerImages/ballybet.png");
  bookmakerKeyPathMap.set("betparx", "https://storage.googleapis.com/assestsbookiebrawler/bookmakerImages/betparx.png");
  bookmakerKeyPathMap.set("fliff", "https://media.licdn.com/dms/image/v2/D560BAQFMvOQzU6dsvw/company-logo_200_200/company-logo_200_200/0/1725401580443/fliff_logo?e=2147483647&v=beta&t=4SxaY7ylG9WVFRNE5EuiKkKutNKTuaS4gHXmvEIBcXg");
  bookmakerKeyPathMap.set("hardrockbet", "https://play-lh.googleusercontent.com/9rkzGFZuueCwoUWWZmCkDMRorSs5byPNKn4n1EYpoDZoj1S72pZ0324oSNdJxjiH3g=w480-h960-rw");
  bookmakerKeyPathMap.set("sisportsbook", "https://storage.googleapis.com/assestsbookiebrawler/bookmakerImages/sisportsbook.jpeg");
  bookmakerKeyPathMap.set("tipico_us", "https://storage.googleapis.com/assestsbookiebrawler/bookmakerImages/tipico.png");
  bookmakerKeyPathMap.set("windcreek", "https://storage.googleapis.com/assestsbookiebrawler/bookmakerImages/windcreek.png");
  bookmakerKeyPathMap.set("thrillzz", "https://storage.googleapis.com/assestsbookiebrawler/icons/thrillz");
  bookmakerKeyPathMap.set("fanatics", "https://storage.googleapis.com/assestsbookiebrawler/bookmakerImages/fanatics.png");
  bookmakerKeyPathMap.set("rebet", "data:image/jpeg;base64,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");
  bookmakerKeyPathMap.set("robinhood", "https://storage.googleapis.com/assestsbookiebrawler/bookmakerImages/robinhood.png");
  bookmakerKeyPathMap.set("parlayplay", "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMwAAADACAMAAAB/Pny7AAAA+VBMVEX/zxA6Ojr/////0Q//0w03ODr/1QwqMDsvMzs0Njo0NDQ8PDr/1wsAAAAxMTHs48/7zzjx5Mafn5/5+fkAAD73zhAqKiojLDzetholJSXvxRMAHT1IRDdeUzRjWDT7zCfVsBzovhcbKDwAFz2/v79sbGzi4uI9PzabgioACj29nSJ7aTGXfStqXTNXTzVXV1fNzc2EhIQYGBgAEz2PjYT/3wCAbi5yZDO0lSZQSjaoiydFRUWUlJRhYWEYIjzKqCCMdy71z0hIOzcYHDywsLBbSjb31GD44qn38OL63Yb56cD10mz33ZHf1L5hW0V5c11ZVkwVGSMpJjoG87KxAAAPOElEQVR4nO2dC3ebOBbHTSSQMDTb1sFgjF0gDztgnNfExm4CpI/pTLszu9Pv/2FWwk1iA+Jlx0nO+t9z2jrYQT90JV1J98qNxk477bTTTjvttNNOO+20007/BwIQCvC5C7EZCdeyrls6+ee5S7K2ZNmcSghjPJiYsvDcpVlLAIafDlUsEmF0OjNl8Nwlqi+oD1XE3UtCB3Pl1bYdqEe2KHGPkk6j10oD9CFaYeE4Poj010kDnAFeZSE0amTBV9hwgD5VuZREPNFeYd0IDofTMJTGenU0AEZ20sgWNMi1XtuAQ6wsG4YT1an1yrwBwRqjbBhOtD3tddWNYM5QNgvt06avi0bQZqyaoTSeluqhiW8twIUE8r+X1IELVk9lwnA88szl4gJBBrplhqFDFYahZilQflog8OvJlXgrVFgdwC+avimABxJFc4aT6UxUEZWq8j03mocW4XkSDijLsgDIzMTSdUWIXxR8YGizWShNb0EDZKjNJz1sI+pd81TUyyZEAy9y9M3PG8gT0sN5NPV6X7+Ov/b63mTu6CCfB5pGjp0RITIlICgNx51hFfHpN4iqKvWG2kZnqcS2rPn0E5mRqAsriP/Fn/pDE+S0U6CM1IwSLkk1yATH6ZFfyHwfsTtjZJWy6zKCUHc8bGMskjtK9+J4EWPVHvs6+0ZQG2c4Zyt1Y/hugMTc9/DY5of6RroCUin+7JD5hFF3MGc+NzLNNJhDTSwJdwtwY4mns3B9WwNQ92cHSMoxfXRlzFnPjdDMsnzNZZzcVvXwLvVgvu48CAJz0rXz7ydJdjANGfNHQjMuoCknif880RrrmBqplnGXL3x0Eh8YrLk9pSljSMUiPkNYnwZAaySVK4ikohFj/kgtLShlSoU0uB82apoaICYmljURCSNXyx50aN183hBNz1Hq1Q00p2J+n7lCI+KpyaIxvx5uiGbsgDo00PRw/oiXupPHohHMXnczNGgW1jA0wfLYozKThrVSATdFw6nj6vMggXi8lW/EowlrLCC+wGZ6AS5wqzYbAEcHNe4tohHjTkDQ+tWfTpakg2HF5QPodGvdCGGfRSNrXoHXWZrGrEQjmAZ7wpt7I3tmshqooE2ze5QmVeavy7wiIaPKaAP0SV2TkLouq9kABk1z/+PZGbefxtnf5zIvSJ+rGBpwKgwwCYm2z3psxNLcVA/ZbN5+OTo//3LxMVno/bMbcuHo5mw/dQ+x/Boi0Kf5fnueJHvM9G6JfzRJukfti/M9qpMvH1cL3bk9atELraPbJA2PovIwvlS7Yoi6PnuQhrq7OpHuHJ/sLdT6wrWXLlzenv+6sHeUqjQ800oaGsxcuy8tCbGrptGQw1XHpvNQZFIF+480Syx7rZt01QxLVg0MB+vNQGyHDXM9WVl9ap+d7D3q6M09zZuz8+Wfc6mq8cq1GqCM1hyrkcucrwuavdIDPFrZotSX7V8sKz8+T8HwklMKJn8dsoxEjuU+AWGaaDK3K6XeO29SmsuzxE/TMGhYyqkRnGDNgZrHPgNGMBNdy/7H1WLvnX/sNDu356s//JIeOUvaGZhfresRIpcxFWhEydZ4+WW13KTrujxOsJxcpEYaTiw1FSCj/7ruLbM/E0Ij2efvf0yUvHV0k6is1vsM70DkcwaAB0HLWHs1BRtmlg0AJUq7M+2zo0TdtJIsUrpiOF4c6iVgzMN1WThRcrLGNMHMWnXqJOsmydLMYCHtclIGJjxdexJF+poMGKAMxayupZ1L876TxRL3AMUwwF9/7UH6GWXAwMyKiWmSlrZUL5fZLBwemyVqZr7+ZF0KMhxBoA9ZvjiThrBkT3Soe1YMA5RNwPycpHszaPaYvjjpBVrVWGgnU9g3E5j1Fx6kn2mHhlQMx/bFM2laNywbi2HCbdWMmxoEgOblTZKIpSVpWu/bbJZtwkySbQYovpQ3fu1fvk/CnByzjYzADIphGhuBCVK9GUjPMZfV3L9IjPtE58edHJgybQZuoGvm7DRMmOdYNPmkD/OL5pINw14GepTwRINm3i56s51RL78sjQnT08q4M2s7zaTXSrozwPJyJkkdBguhuX3DgpmW8ACgtuakmYsbZwIGhjmrmW+OGSiU5iybhheZy9rLt1U2MAX4mrwRGLLr+80Fm4VJw+MyU00ANzE5S7BAvcda7uU7uSy03WT1acSSywQGyOEGps1JK9MOWb+zfZMs/HkrSdNOf0ws05nR2Vl/3QWNQTKeVHBYGySd42TRL5rJ4fM8vUDLYbdUzCqZDwZrsRArSxqAwGoyfCc13293uARNxryZNJlyu+jQyXU8ipVeBBRYnUo7sah0ckHmYvtJmvQioGgk+0sWzOaXZ6HHiKJLLALGLHQvY5UmvW6GpmVjT2B2bHVZmG5qTwMAli/TXlkEPLntLEq931mhOU+um/HivOwOzZpbGr3UQwPAZkxlmvtLbWbJeVmpm9b7JAw2ym/QQKcgAixHfDe9bA5gwPp9nYvWI8vSgNJs3zxcSPVmvFph6wwo9bcBryYZIzNgukjNzpcsFnLh8p6mdZEcZ/CnKjk40MqJSM6VPctaNAfsMNom8TJbREe3iSI3L4/jC+dnKQ/Adq7LsxAjd4JU4ksZYSlzb0aO2DO+Zmf/+OL4rJMe5tvts4uLrAvqpFJ2FIRDppnnseDsRVPBzwuRaLY7jJU+cqGdNXW2y7jMSzT6pHonIOIo28mA2tVG4hnuxdvlvJmH+1surkhD5hiMQCDiNefFntegQdXyiaA2qUbDs9OvQGMDyyQrqprrBShNhSKoOQ8L1o1fyaFxq9FYUTIxkSmJZ8eZNOIdgM3ENC3RILdSdhTUR0G5Byqhw0jJ8zBAUVpAddEMnEo00JnZJfoh3h74+akhQJnXj8dhKagWFQhlLUJFfbSIsFuYgA2sSdUwyUJJQb/U5PlBguJ7pLQc00ZEJPZ9vfAJgbwtjdo0qmdWiqaFwJp7vIr4jCB6ScK22J9rZYLZgOIUJDnUEM2OqlQ3ADYsfzKzP6txvsk9BvkfCg4Nd64p5R4OUPz11xfTNMyIXVYxANDNedQ7PD0M1DiVCqsBeTFz56FeEqVB1xfnqIb7mv8JXp1WzS0mOFDXQmfkeoaoqnjQmwz9UNMBrGKyxNKKUj7SKGJRqlBQLowmwQMhVBSaPxdn0CnkddVQdgC0/mmFTo0XURd5BSsSYlCt2SyV5j61sVZIPjW1sG/TrD8+E+khE5BYMkZqgDxfVxwut+OQuvOitMSnEoCy5bgGj0lhk8IPIkTc2B2GuixAULSQhwclgjWeSlCWgWX6w8idel4/ljedupPRcO77cfKsaWoWoGmhsf0AwcmN5+Ht5z0sAUBBluP0ZYWIGi95QfNYqYRYcPndTl7mGm/XydzYuMCSct8n5A24fJATFPoCBYRwxlwzfm0wMQ1rRsTbNfvmZxMQzDFjNiKKJfZqX5YAICNUFo1kT2tm1T2ngJlJI52+siYTCwCzl6aRPvdf6HlJBX20oPVT8QQYhS/xZBHw4e3bu7u7t2/ZbxG0ZI4iVv3n8szy9Pb3b614F+OPbz+YPLLm4qV4Yh4N/Bd1CMpCH/58t7Tx9/0HazNZ0IczOj+MvWvEe+ELrJe7byv7y6R2WJUjwDDqLyYJA3duvUSW76kQzW9vGcUEgmI68+GQTHWJa73dcpbR3fckCqVhvh3QKW881d1iGctK/5bBstf6M+cjRX728+lHVlAzaTe/P3fBakjJrBiifz93yWro7g8GzLu7F2pKOfrBYNn748frg2FZ2V7r1dkZ+PCOBbP3PcdNW+ue8Il8IPDhX0yYd08AA6AA6Rj1NOfAbRcGNjQ/8vqe62tK/YVZlrZbM9CKJHqwmYpEqT9yLFBjxTxPW4QBcjiwFwebcTzGiO6U0U0ZYVOnwW2zZgT/anUtUUTBle3OQ01vbOYQ9u3ByGE3FdcgSaJ9dcBPR75p0W2bNX2+rcFAPTuKTqJbs4eBQY85NC1idfWJtmdmss/OriCNCNuBavSmI2J0hCjeg3q5MKCRm/W2AEI2loyeO/IXRHLFKdPWYASt6EQ/CkS3HhHmB0bfHc2d0NJB8XmhS9oWjJzOeWeKbuyJomTMptFw7mi6cL/xVaCt1Yzsc9WOOFtsrmLe6E8nEensAN0JK2hILxXmHomnX89AWpIx9kj/rROga5l1Eur2aqaCmWVALfa/1cAej3xHUwT5+vpaTlGVgqHbtfTD19e1F5ahPt5I7A4KDg+IcM8dhiY9h/lRAObCPJyorJu+Z2BuHJlKXd9ddjcTiLQ4rRarwdXBwaktxv2e75iaZlm69leLoZO/7iwzdPzhpCd1Dw5sJGL18LTHOoC0EMYsffhkaSaJJ7ZnH56eXnVtlTSs2d//+e3mt99ubt4/irz+7eLv/37kkN29Or0KVMwvIqrIX/bVqOaGjBzZxSec1qWKWxVC6J83Wbr8pyPSg4ilx8CwxWf5q5pfxyHorl0rK6AKWaUfc3SvnHX0YIGgNcXqU1TOOhK5ckc1ZdAMDdUWK4aJPbGQWzP2ByrhyOO6AZZeDpA4K5kNmBIAihXOJ9LBofpSeHiRefJgMQ6ZIOtWOOpfnQYbj06uo7JHgjGByIRfsZzRGJPRIe4ynxUmWjdgjvoWgAJ5AzLwISw+G9C6NXMPRL8Zj7ShodszRPsneh4gArOxpTsauAf00I/csWQTl2nrzUgseSZgeSDizeuaM4+8QU487NMIlTytsZJILwcVyyRE458I0/DXrdRS+XM0K4oGi9JugdZR36AuMUK0lp5yRFL7xWkhaxDF/ZyiW6Y/cscDiX7dCsKxx7t5FEkdVDuxuRZRHI8ug7ghTXszSbQDW6X93SaJJLFb9mSDTSiOWSZIoT+K3D7p7ygSpoHx64KQX4EDfrL1rxWjYdixz2CG/jyaTMcSUu/j48VFzyfFf4oqgr4lXu6hQrgXhbmZek+KRPs7QBqTZjr+fBh5Y+MTtToRL8X/L77ZaKniFukN+D5fANOpu2R4EU1zUZ43jmmR2hGHylsWoQoJ1sidev3eeDabGYYhcUslvweUBuQKud7re9No7jvxSnbjqbaJq+vXuhFoKDQPR6dgZhhSNhpxNRyO7kVfLHIcTJMm6xAKUPY7vLat+yyceFeH+FggTm9ICDR+XVtk67yUCikSyNRaX5yz00477bTTTjvttNNOO+2000477bTTM+l/yKugWtsWOc4AAAAASUVORK5CYII=");
  bookmakerKeyPathMap.set("betanysports","https://media.licdn.com/dms/image/v2/D4E0BAQFKrSfPKZCdZg/company-logo_200_200/company-logo_200_200/0/1705332205487/betanysports_logo?e=2147483647&v=beta&t=GMQarCE3WetdLqpZK1ie3ARXpIRlLqrY_0Rl4EQFiAI");

  // DFS / Pick'em sources
  bookmakerKeyPathMap.set("prizepicks", "https://play-lh.googleusercontent.com/vEqCDavx465HGjdtLGd5o-zH4TfMAXVSbx_ZlqvNRPKVFbV3eUN7-signMjiOHoAAYs=w240-h480");
  bookmakerKeyPathMap.set("underdog", "https://play-lh.googleusercontent.com/p3pBxiJ5FUAdUINQEuDrW6FyVBOtKe0Wv8PmLxAMXvd0yh6Us466mpefl6NYsWWfwf8=w480-h960-rw");
  bookmakerKeyPathMap.set("pick6", "https://www.google.com/s2/favicons?sz=128&domain=draftkings.com");
  bookmakerKeyPathMap.set("betr_us_dfs", "https://play-lh.googleusercontent.com/D6zsgpao70v4cT1iXWbg5nYHkcILVbK6vWrVqlS1VqGYxEFWJts9QxbBnMUikquhYqX8=w480-h960-rw");

  // Exchanges
  // Self-hosted marks. The pm.wiki endpoints these used to point at
  // answer text/html rather than an image, so the <img> always failed
  // and every row fell back to initials; Pinnacle had no entry at all.
  // Local SVGs can't rot or be hotlink-blocked like the remote logos.
  bookmakerKeyPathMap.set("novig", "/logos/books/novig.svg");
  bookmakerKeyPathMap.set("prophetx", "/logos/books/prophetx.svg");
  bookmakerKeyPathMap.set("pinnacle", "/logos/books/pinnacle.svg");
  bookmakerKeyPathMap.set("betopenly", "https://play-lh.googleusercontent.com/J6cm-9wvZ9zNRw1wqi333who-ohL2o5jERtNqehdrAYlY4F8M_WormRGqJwBxg9G6AY=w480-h960-rw");
  bookmakerKeyPathMap.set("matchbook", "https://betting.exchange/wp-content/uploads/2015/07/matchbook.png");

  // Prediction Markets
  bookmakerKeyPathMap.set("kalshi", "https://play-lh.googleusercontent.com/5_nqrDLjGT0QhL4oHiJvsOqo2oQ0ecQmIDxh2CtsUbcVFRSEZSCqWB-Do29kTgKBE64=w480-h960-rw");
  bookmakerKeyPathMap.set("polymarket", "https://play-lh.googleusercontent.com/mSWhIFeEm9zYNzSngRw8QGdhowcYrfsTzPj_M6jOrE6aM7r5ooFZ-qulfuxL66fsOLdao8znTQ2Mw4cXV5ImEpk=w480-h960-rw");

  // AU Sportsbooks
  bookmakerKeyPathMap.set("dabble", "https://play-lh.googleusercontent.com/50N1REiT81GJeNikxOVo1OwpYUZTZovQUdBbuPdDetyTMGknKt2gSYA8-dMM4_OEUww=w480-h960-rw");
  bookmakerKeyPathMap.set("dabble_au", "https://play-lh.googleusercontent.com/50N1REiT81GJeNikxOVo1OwpYUZTZovQUdBbuPdDetyTMGknKt2gSYA8-dMM4_OEUww=w480-h960-rw");
  bookmakerKeyPathMap.set("pointsbetau", "https://www.google.com/s2/favicons?sz=128&domain=pointsbet.com.au");
  bookmakerKeyPathMap.set("sportsbet", "https://play-lh.googleusercontent.com/wOdlx0iiaLRuKIeR7-zPlPHz8QDWqjdV4N0yckRAJPXXhEyq92ZiJVYpRoxdEXTSh_Y=w240-h480");
  bookmakerKeyPathMap.set("ladbrokes_au", "https://www.google.com/s2/favicons?sz=128&domain=ladbrokes.com.au");
  bookmakerKeyPathMap.set("neds", "https://play-lh.googleusercontent.com/ONeF_kIaGL1DQODaWslcUqDJ51hC-m6mPHC1qfmqmVTB6TKd3kbsZWeoXjrv-um-4w=w240-h480");
  bookmakerKeyPathMap.set("tab", "https://www.google.com/s2/favicons?sz=128&domain=tab.com.au");
  bookmakerKeyPathMap.set("tabtouch", "https://www.google.com/s2/favicons?sz=128&domain=tabtouch.com.au");
  bookmakerKeyPathMap.set("unibet", "https://play-lh.googleusercontent.com/16nl0orq2mIWpxG6c2ew9jXgjhSiyx9_r3t7Pms30nHr8TlGGn54B8EwxMhNRueFhB8=w480-h960-rw");
  bookmakerKeyPathMap.set("betr_au", "https://www.google.com/s2/favicons?sz=128&domain=betr.com.au");
  bookmakerKeyPathMap.set("betright", "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/af/b5/db/afb5db1d-66fb-043d-00e4-f7a2e33ae145/AppIcon-1x_U007emarketing-0-8-0-85-220-0.png/512x512bb.jpg");
  bookmakerKeyPathMap.set("playup", "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/c6/cf/cc/c6cfccb7-657c-6423-9f3f-9626bacd69fa/AppIcon-0-0-1x_U007epad-0-1-0-85-220.png/512x512bb.jpg");

  // EU/AU Exchanges (Betfair)
  bookmakerKeyPathMap.set("betfair_ex_eu", "https://play-lh.googleusercontent.com/ffl3ON0cR0dAhKfVflhm2amupEk3fUfftZAAcFcmd_5iOmV1iT4oy75cjmJy0PpTy4I=w480-h960-rw");
  bookmakerKeyPathMap.set("betfair_ex_au", "https://play-lh.googleusercontent.com/ffl3ON0cR0dAhKfVflhm2amupEk3fUfftZAAcFcmd_5iOmV1iT4oy75cjmJy0PpTy4I=w480-h960-rw");


 

  
  const normalizedKey = key.toLowerCase();
  const exact = bookmakerKeyPathMap.get(key) || bookmakerKeyPathMap.get(normalizedKey);
  if (exact) return exact;

  if (key.includes("hardrock") || key.includes("hard_rock")) {
    return "https://play-lh.googleusercontent.com/9rkzGFZuueCwoUWWZmCkDMRorSs5byPNKn4n1EYpoDZoj1S72pZ0324oSNdJxjiH3g=w480-h960-rw";
  }
  if (normalizedKey.includes("dabble")) {
    return "https://play-lh.googleusercontent.com/50N1REiT81GJeNikxOVo1OwpYUZTZovQUdBbuPdDetyTMGknKt2gSYA8-dMM4_OEUww=w480-h960-rw";
  }

  return "";
}

/**
 * Human name for a bookmaker key.
 *
 * Keys reach the frontend in several shapes — the catalog key
 * (`hardrockbet`), the normalized one the arb/EV wire emits (`hard_rock`),
 * and regional or DFS variants the catalog never lists (`dabble_us_dfs`).
 * The substring rules below mirror the ones in
 * {@link getImagePathByMarketKey} so a book's name and its logo always agree,
 * and anything still unrecognised is title-cased rather than shown raw.
 */
export function getBookieDisplayName(key: string): string {
  if (!key) return "";

  const normalizedKey = key.toLowerCase();
  const catalogued = allBookmakersWithSource.find(
    (b) => b.key === key || b.key === normalizedKey
  );
  if (catalogued) return catalogued.title;

  if (normalizedKey.includes("hardrock") || normalizedKey.includes("hard_rock")) {
    return "Hard Rock Bet";
  }
  if (normalizedKey.includes("dabble")) return "Dabble";
  if (normalizedKey.includes("pointsbet")) return "PointsBet";
  if (normalizedKey.includes("williamhill")) return "Caesars";
  if (normalizedKey.includes("betfair")) return "Betfair";
  if (normalizedKey.includes("unibet")) return "Unibet";

  return key
    .split(/[_\s]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}

export function getIconPathBySportKey(key: string): string {
  const sportKeyToIconPathMap = new Map<string, string >();
  sportKeyToIconPathMap.set("basketball_nba", "/icons/sports/basketball.png");
  return sportKeyToIconPathMap.get(key)||"";
}

export function getImagePathByTeamTitle(key: string): string {
  const bookmakerKeyPathMap = new Map<string, string >();

  bookmakerKeyPathMap.set("Boston Celtics", "");
  bookmakerKeyPathMap.set("Brooklyn Nets", "");
  bookmakerKeyPathMap.set("New York Knicks", "");
  bookmakerKeyPathMap.set("Philadelphia 76ers", "");
  bookmakerKeyPathMap.set("Toronto Raptors", "");
  bookmakerKeyPathMap.set("Chicago Bulls", "");
  bookmakerKeyPathMap.set("Cleveland Cavaliers", "");
  bookmakerKeyPathMap.set("Detroit Pistons", "");
  bookmakerKeyPathMap.set("Indiana Pacers", "");
  bookmakerKeyPathMap.set("Milwaukee Bucks", "");
  bookmakerKeyPathMap.set("Atlanta Hawks", "https://upload.wikimedia.org/wikipedia/en/thumb/2/24/Atlanta_Hawks_logo.svg/1200px-Atlanta_Hawks_logo.svg.png");
  bookmakerKeyPathMap.set("Charlotte Hornets", "");
  bookmakerKeyPathMap.set("Miami Heat", "");
  bookmakerKeyPathMap.set("Orlando Magic", "https://upload.wikimedia.org/wikipedia/en/thumb/1/10/Orlando_Magic_logo.svg/1200px-Orlando_Magic_logo.svg.png");
  bookmakerKeyPathMap.set("Washington Wizards", "");
  bookmakerKeyPathMap.set("Dallas Mavericks", "");
  bookmakerKeyPathMap.set("Houston Rockets", "");
  bookmakerKeyPathMap.set("Memphis Grizzlies", "");
  bookmakerKeyPathMap.set("New Orleans Pelicans", "");
  bookmakerKeyPathMap.set("San Antonio Spurs", "");
  bookmakerKeyPathMap.set("Denver Nuggets", "");
  bookmakerKeyPathMap.set("Minnesota Timberwolves", "");
  bookmakerKeyPathMap.set("Oklahoma City Thunder", "");
  bookmakerKeyPathMap.set("Portland Trail Blazers", "");
  bookmakerKeyPathMap.set("Utah Jazz", "");
  bookmakerKeyPathMap.set("Golden State Warriors", "");
  bookmakerKeyPathMap.set("Los Angeles Clippers", "");
  bookmakerKeyPathMap.set("Los Angeles Lakers", "");
  bookmakerKeyPathMap.set("Phoenix Suns", "");
  bookmakerKeyPathMap.set("Sacramento Kings", "");
return bookmakerKeyPathMap.get(key)||"";
}

export function isGuaranteedProfit(prices: number[]): boolean {

  const numOfOutcomes =  prices.length;
  const minOddLimit = (numOfOutcomes -1)*(100);

  let isGuaranteedProfit = true;
  prices.forEach((price) => {
    if(price<minOddLimit) isGuaranteedProfit = false;
  })
  return isGuaranteedProfit;
}

// export function formatDate(dateString: string): string {
//   // Parse the date string into a Date object
//   const date = new Date(dateString);

//   // Extract the individual date and time components
//   const dayOfWeek = date.toLocaleDateString("en-US", { weekday: "short" });
//   const month = date.toLocaleDateString("en-US", { month: "short" });
//   const dayOfMonth = date.getDate();

//   const hours = date.getHours();
//   const minutes = date.getMinutes();
//   const ampm = hours >= 12 ? "PM" : "AM";

//   let regularHours = hours;
//   let regularMinutes = minutes < 10 ? "0" + minutes : minutes;

//   if (hours === 0) {
//     regularHours = 12;
//   } else if (hours > 12) {
//     regularHours = hours - 12;
//   }

//   const time = `${regularHours}:${regularMinutes}`;

//   // Assemble the formatted date string
//   return `${dayOfWeek}, ${month} ${dayOfMonth}, ${time} ${ampm}`.toUpperCase();
// }

export function formatDate(dateString: string): string {
  // Append 'Z' to indicate that dateString is in UTC
  const date = new Date(dateString + "Z");

  // Format the date and time components
  const dateOptions: Intl.DateTimeFormatOptions = { weekday: "short", month: "short", day: "numeric" };
  const timeOptions: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit', hour12: true };
  const formattedDate = date.toLocaleDateString("en-US", dateOptions);
  const formattedTime = date.toLocaleTimeString("en-US", timeOptions);

  // Assemble the formatted date string
  return `${formattedDate}, ${formattedTime}`.toUpperCase();
}





export function getSportByKey (key: string) : Leagues{
  
  let league = leagueList.find(s => s.key === key) as Leagues;
  return league;
}
 

export function getBestOddsPerMarketPerOutcomeFromEvent(odd: Odds, marketKey : string):BestOdds {
  
  let bestOdds: BestOdds = {
    home: {
      name: '',
      price: Number.MIN_SAFE_INTEGER,
      point: Number.MIN_SAFE_INTEGER,
    },
    away: {
      name: '',
      price: Number.MIN_SAFE_INTEGER,
      point: Number.MIN_SAFE_INTEGER,
    },
    homeBookmaker: "",
    awayBookmaker: "",
    homeTeamName: "",
    awayTeamName: ""
  };

  const bookmakers =odd.bookmakers;
  for (const bookmaker of bookmakers) {
    if(shouldExclude(bookmaker.key)) continue;
    const market = getMarketByKey(marketKey, bookmaker.markets);
    
    if (!market) continue;

    
    const awayOdds: Outcome = market.outcomes[0];
    const homeOdds: Outcome = market.outcomes[1];

    if(awayOdds.price > bestOdds.away.price){
      bestOdds.away= awayOdds;
      bestOdds.awayBookmaker = bookmaker.key;
    }

    if(homeOdds.price > bestOdds.home.price){
      bestOdds.home= homeOdds;
      bestOdds.homeBookmaker = bookmaker.key;
    }

    
    
    
  
  }

  return bestOdds;
}



// function getBetterOutcome (current: Outcome, best: Outcome) : Outcome{
//   if(current.price > best.price)
  
//   return current.price > best.price? current: best;
// }

export function getMarketByKey(key: string, markets: Market[]): Market| null {
  // Iterate over the markets array
  for (const market of markets) {
    // Check if the key of the current market matches the given key
    if (market.key === key) {
      // If it does, return the market
      return market;
    }
  }
  return null;
}


export function getBestJuicePerMarketFromEvent(json: Odds):BestForMarket [] {
  
  const lowestJuices = new Map<string, BestForMarket >(); ;
  
  let bestForMarkets: Array<BestForMarket> = [];

  const bestBetForLines = {
    market: { juice :Number.MAX_SAFE_INTEGER,
  }} as BestForMarket;
  const bestBetForTotals ={
    market: { juice :Number.MAX_SAFE_INTEGER,
  }} as BestForMarket;
  const bestBetForSpreads = {
    market: { juice :Number.MAX_SAFE_INTEGER,
  }} as BestForMarket;
  
  lowestJuices.set("totals", bestBetForTotals);
  lowestJuices.set("spreads", bestBetForSpreads);
  lowestJuices.set("h2h", bestBetForLines);

  for (const bookmaker of json.bookmakers) {
    if(shouldExclude(bookmaker.key)) continue;
    for (const market of bookmaker.markets) {  
      if (market.key.endsWith('_lay')) continue;
      let bestForMarket = lowestJuices.get(market.key)
      if(!bestForMarket) continue;
      if (lowestJuices.has(market.key) && market.juice < bestForMarket.market.juice) {
        bestForMarket.market = market;
        bestForMarket.bookmaker = bookmaker;
        lowestJuices.set(market.key, bestForMarket);
      }
    }
  }
 
  bestForMarkets =  Array.from(lowestJuices.values());
  return bestForMarkets;
}


